import { useCallback } from 'react';
import {
  FieldValues,
  UseFormGetValues,
  UseFormSetError,
} from 'react-hook-form';

import Logger from 'browser-logging/src/browser/Logger';

import { ApiError } from 'common/src/exceptions/ErrorHandling';

import { MESSAGES } from 'portal/src/constants/snackbarMessages';

import { formControlErrors } from './formControlErrors';

type FormControl<TFieldValues extends FieldValues> = {
  getValues: UseFormGetValues<TFieldValues>;
  setError: UseFormSetError<TFieldValues>;
};

/**
 * Custom hook to handle form control errors and generate appropriate snackbar
 * messages depending on API error received.
 */
const useFormControlError = <TFieldValues extends FieldValues>(
  formControl: FormControl<TFieldValues>,
) => {
  const getSnackbarApiErrorMessage = useCallback(
    (error: unknown): string => {
      let snackbarMsg = MESSAGES.GENERIC.ERROR;

      if (ApiError.compatible(error)) {
        snackbarMsg = MESSAGES.GENERIC.FORM_FIELDS_ERROR;
        formControlErrors(formControl, error);
      } else {
        Logger.captureError(error as Error);
      }

      return snackbarMsg;
    },
    [formControl],
  );

  return { getSnackbarApiErrorMessage };
};

export default useFormControlError;
